<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <span style="font-size: 30px" class="form-header font-weight-bold"
          >Conciliación Bancaria
          <img
            src="data:image/png;base64,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
"
        /></span>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row row justify-content-end">
            <div class="col-2">
              <label>Fecha</label>
              <input v-model="filter.fecha" class="form-control" type="date" />
            </div>
            <div class="col-2">
              <label>Número</label>
              <input v-model="filter.numero" class="form-control" type="text" />
            </div>
            <div class="col-2">
              <label>conciliado</label>
              <select v-model="filter.conciliado" class="form-control" type="date">
                <option :value="true">CONCILIADO</option>
                <option :value="false">NO CONCILIADO</option>
              </select>
            </div>
            <div class="col-2">
              <label>Estado</label>
              <select v-model="filter.estado" class="form-control" type="date">
                <option value="">TODOS</option>
                <option value="A">ABIERTO</option>
                <option value="B">CERRADO</option>
                <option value="9">ANULADO</option>
              </select>
            </div>
            <div class="text-center col-2">
              <br />
              <button @click="filterData()" class="btn btn-success btn-lg">
                <i class="fas fa-search"></i>
              </button>
              <button @click="clearFilterData()" class="btn btn-dark btn-lg">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <br />
          <br />
          <div
            style="border-bottom: #e2e2e2 solid 0.1px; border-top: #e2e2e2 solid 0.1px"
          >
            <nav>
              <div
                class="nav nav-tabs col-12 d-flex justify-content-center"
                id="nav-tab"
                role="tablist"
              >
                <a
                  class="col-4 text-center nav-item nav-link active"
                  id="movimientos_bancarios-tab"
                  @click="tipo_transac = 'mov_banc'"
                  data-toggle="tab"
                  href="#movimientos_bancarios"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="true"
                >
                  <span class="font-weight-bold" style="font-size: 15px"
                    >Movimientos Bancarios
                    <i
                      style="font-size: 20px"
                      v-if="tipo_transac == 'mov_banc'"
                      class="fas fa-check"
                    ></i
                  ></span>
                </a>
                <a
                  class="col-4 nav-item nav-link text-center"
                  id="nav-abonos-tab"
                  data-toggle="tab"
                  @click="tipo_transac = 'abono'"
                  href="#abonos-home"
                  role="tab"
                  aria-controls="abonos-home"
                  aria-selected="false"
                >
                  <span class="font-weight-bold" style="font-size: 15px"
                    >Abonos
                    <i
                      style="font-size: 20px"
                      v-if="tipo_transac == 'abono'"
                      class="fas fa-check"
                    ></i
                  ></span>
                </a>
              </div>
            </nav>
          </div>
          <div class="tab-content element-box" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="movimientos_bancarios"
              role="tabpanel"
              aria-labelledby="movimientos_bancarios-tab"
            >
              <h6 class="text-success">
                Movimientos Bancarios &nbsp;<i class="fas fa-landmark fa-2x"></i>
              </h6>
              <div class="invoice-table">
                <table class="table table-striped">
                  <thead>
                    <th>Número</th>
                    <th class="text-center">Núumero</th>
                    <th class="text-center">Tienda</th>
                    <th class="text-center">Tipo Movimiento</th>
                    <th class="text-right">Total cargo</th>
                    <th class="text-right">Total Abono</th>
                    <th class="text-center">Fecha</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">Conciliación</th>
                    <th class="text-center"></th>
                  </thead>
                  <tbody>
                    <tr v-for="det in movimientos_bancarios.results" v-bind:key="det.id">
                      <td>{{ det.numero }}</td>
                      <td class="text-center">{{ det.numero }}</td>
                      <td class="text-center">{{ det.tienda.nombre }}</td>
                      <td class="text-center">{{ det.tipo_movimiento_str }}</td>
                      <td class="text-right">{{ det.total_cargos }}</td>
                      <td class="text-right">{{ det.total_abonos }}</td>
                      <td class="text-center">{{ det.fecha }}</td>
                      <td class="text-center">{{ det.estado_str }}</td>
                      <td class="text-center">
                        <i
                          class="fas fa-check"
                          v-if="det.conciliado"
                          style="color: green"
                        ></i>
                        <i
                          class="fas fa-times"
                          v-if="!det.conciliado"
                          style="color: red"
                        ></i>
                      </td>
                      <td>
                        <button
                          @click="conciliarMovimientoBanc(det)"
                          type="checkbox"
                          class="btn btn-success btn-sm"
                        >
                          Conciliar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <PaginationComponent
                :currentPage="currentPage"
                :data="movimientos_bancarios"
                @pagechanged="onPageChange"
              />
            </div>

            <div
              class="tab-pane fade"
              id="abonos-home"
              role="tabpanel"
              aria-labelledby="nav-abonos-tab"
            >
              <h6 class="text-success">
                Movimientos de Abonos &nbsp;<i class="fas fa-coins fa-2x"></i>
              </h6>
              <div class="invoice-table">
                <table class="table table-striped">
                  <thead>
                    <th class="text-center">Documento</th>
                    <th class="text-center">Tipo Abono</th>
                    <th class="text-right">Total cargo</th>
                    <th class="text-right">Total Abono</th>
                    <th class="text-right">Valor</th>
                    <th class="text-center">Fecha documento</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">Conciliación</th>
                    <th class="text-center"></th>
                  </thead>
                  <tbody>
                    <tr v-for="det in abonos.results" v-bind:key="det.id">
                      <td class="text-center">{{ det.documento }}</td>
                      <td class="text-center">{{ det.tipo_abono_obj.nombre }}</td>
                      <td class="text-right">{{ det.total_aplicado }}</td>
                      <td class="text-right">{{ det.total_pendiente }}</td>
                      <td class="text-right">{{ det.valor }}</td>
                      <td class="text-center">{{ det.fecha_documento }}</td>
                      <td class="text-center">{{ det.estado_str }}</td>
                      <td class="text-center">
                        <i
                          class="fas fa-check"
                          v-if="det.conciliado"
                          style="color: green"
                        ></i>
                        <i
                          class="fas fa-times"
                          v-if="!det.conciliado"
                          style="color: red"
                        ></i>
                      </td>
                      <td>
                        <button
                          @click="conciliarAbono(det)"
                          type="checkbox"
                          class="btn btn-success btn-sm"
                        >
                          Conciliar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <PaginationComponent
                :currentPage="currentPage"
                :data="abonos"
                @pagechanged="onPageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    UsuariosSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      tipo_transac: "todos",
      current: {
        estado: "A",
      },
      det: [],
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      movimientos_bancarios: [],
      abonos: [],
      filterActive: null,
      filter: {
        numero: "",
        tienda: "",
        fecha: null,
        usuario: "",
        cuenta_bancaria: "",
        tipo_movimiento: "",
        conciliado: "",
        estado: "",
      },
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    conciliarMovimientoBanc(params) {
      let self = this;
      Notifications.alert.confirm(
        "Conciliar el movimiento bancario",
        "¿Esta segura(a)?",
        "si",
        function () {
          DynamicService.postAction(
            "bancos",
            "movimiento-bancario",
            params.id,
            "conciliar_movimiento"
          )
            .then((response) => {
              self.filterData();
              Notifications.alert.success(
                "Conciciliar movimiento bancario",
                "Realizado exitosamente"
              );
            })
            .catch((error) => {
              Notifications.alert.error(
                "Conciciliar movimiento bancario",
                error.response.data.detail
              );
              self.filterData();
            });
        }
      );
    },
    conciliarAbono(params) {
      let self = this;
      Notifications.alert.confirm(
        "Conciliar el abono",
        "¿Esta segura(a)?",
        "si",
        function () {
          DynamicService.postAction("cxp", "abonos", params.id, "conciliar_abono")
            .then((response) => {
              self.filterData();
              Notifications.alert.success("Conciciliar abono", "Realizado exitosamente");
            })
            .catch((error) => {
              Notifications.alert.error("Conciciliar abono", error.response.data.detail);
              self.filterData();
            });
        }
      );
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    filterData(page) {
      let usuario = "";
      let fecha = "";
      if (page) {
        this.currentPage = page;
      }
      if (this.filter.fecha) {
        fecha = moment(this.filter.fecha).format("DD/MM/YYYY");
      }
      if (this.filter.usuario) {
        usuario = this.filter.usuario.id;
      }
      this.refreshData({
        numero: this.filter.numero,
        estado: this.filter.estado,
        documento: this.filter.numero,
        fecha: fecha,
        conciliado: this.filter.conciliado,
        estado: this.filter.estado,
        page: this.currentPage,
      });
    },
    clearFilterData() {
      let self = this;
      this.filter.numero = "";
      this.filter.estado = "";
      this.filter.documento = "";
      this.filter.fecha = null;
      this.filter.conciliado = "";
      this.page = this.currentPage;
      this.refreshData();
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      if (this.tipo_transac == "mov_banc") {
        this.refreshbancarios(params);
      }
      if (this.tipo_transac == "abono") {
        this.refreshAbono(params);
      }
      if (this.tipo_transac == "todos") {
        this.refreshbancarios(params);
        this.refreshAbono(params);
      }
    },
    refreshbancarios(params) {
      let self = this;
      DynamicService.fetch("bancos", "movimiento-bancario", params)
        .then((res) => {
          self.movimientos_bancarios = res.data;
        })
        .catch((error) => {
          self.data = "";
        });
    },
    refreshAbono(params) {
      let self = this;
      DynamicService.fetch("cxp", "abonos", params)
        .then((res) => {
          self.abonos = res.data;
        })
        .catch((error) => {
          self.data = "";
        });
    },
    showModalEdit() {},
  },
};
</script>
